import React from "react";
import SizeDropdown from "../../../../components/shop/SizeDropdown/SizeDropdown";
import { useMultilingual } from "../../../../hooks/useMultilingual";
import { useLanguage } from "../../../../context/LanguageContext";
import { getLocalizedOptionName } from "../../../../utils/multilingualUtils";

const VariantSelector = ({
    variantTypes,
    selectedVariantOptions,
    onVariantChange,
    getAvailableOptions,
    variantError,
    product // Add product prop to access option names
}) => {
    const multilingual = useMultilingual();
    const { language } = useLanguage();

    // Translations for variant selector
    const translations = {
        en: {
            select: "Select",
            choose: "Choose",
            pleaseSelect: "Please select a"
        },
        ar: {
            select: "اختر",
            choose: "اختر",
            pleaseSelect: "يرجى اختيار"
        }
    };

    const t = translations[language] || translations.en;

    const renderVariantSelector = (variantType) => {
        const options = getAvailableOptions(variantType);
        const selectedValue = selectedVariantOptions[variantType] || '';
        const hasError = variantError && !selectedValue;

        // Get localized option name - find by comparing multilingual text
        const optionName = product?.options?.find(opt => {
            const optionNameText = getLocalizedOptionName(opt, 'en') || '';
            return optionNameText.toLowerCase() === variantType.toLowerCase() ||
                multilingual.getOptionName(opt).toLowerCase() === variantType.toLowerCase();
        });
        const localizedOptionName = optionName ? multilingual.getOptionName(optionName) :
            variantType.charAt(0).toUpperCase() + variantType.slice(1);

        const containerStyle = {
            border: hasError ? '0px solid red' : '0px solid #ccc',
            padding: '8px',
            borderRadius: '1px',
            marginBottom: '10px'
        };

        // Process options to get localized display text
        const processedOptions = options.map(optionValue => {
            // Try to get localized text using multilingual utils
            const displayText = multilingual.getOptionValue(optionValue, variantType);
            return {
                value: optionValue,
                displayText: displayText
            };
        });

        // Use SizeDropdown for all variant types
        return (
            <div key={variantType} className="variant-item">
                <label
                    className="size-label"
                    style={{ color: hasError ? "#b00020" : "#1a1a1a" }}
                >
                    {localizedOptionName.toUpperCase()}
                </label>

                <SizeDropdown
                    options={processedOptions}
                    selectedValue={selectedValue}
                    onChange={(value) => onVariantChange(variantType, value)}
                    placeholder={`Choose ${localizedOptionName.toLowerCase()}`}
                />

                {hasError && (
                    <p style={{ color: "red", marginTop: "5px" }}>
                        {t.pleaseSelect} {localizedOptionName.toLowerCase()}.
                    </p>
                )}
            </div>
        );
    };

    if (variantTypes.length === 0) return null;

    return (
        <div className="variants-section">
            <div className="variant-divider"></div>
            {variantTypes.map((variantType) => renderVariantSelector(variantType))}
        </div>
    );
};

export default VariantSelector;